// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Inter', var(--cairo-font)","fontStyle":"normal"},"className":"__className_dfd4e9","variable":"__variable_dfd4e9"};